require('./KeysSendView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
import { withRouter } from 'react-router-dom';

// @ actions
const UserData = require('actions/contactCenter/userData');
const CodeOTP = require('actions/contactCenter/codeOtp');
const profileActions = require('actions/profile');
const recoveryKeys = require('actions/contactCenter/recoveryKeys');
const  loginAsClient  = require('actions/contactCenter/loginAsClient');
const KeysSendView = require('components/myProfile/KeysCCSteps/KeysSendDisasterView');


class KeysSendDisasterViewContainer extends React.Component {

    componentWillReceiveProps(nextProps){
        if (nextProps.immLoginAsClient.get('hasBeenFetch')) {
            this.props.history.push('myprofile/global');
        }
    }

    render() {
       return (
           <KeysSendView {...this.props} />
        );
    }
}

KeysSendDisasterViewContainer.propTypes = {
    history: PropTypes.object.isRequired,
    immCustomerFinder: PropTypes.object.isRequired,
    immUserData: PropTypes.object,
    immCodeOTPData : PropTypes.object,
    immKeysData : PropTypes.object,
    immProfileFields: PropTypes.object,
    immLoginAsClient: PropTypes.object,
    requestcodeOTP: PropTypes.func,
    requestSendKey : PropTypes.func,
    requestPhoneOTP: PropTypes.func,
    requestcodeOTPReset : PropTypes.func,
    requestSendKeyReset: PropTypes.func,
    requestGetProfile :  PropTypes.func,
    handleRequestLogin : PropTypes.func,
    requestClientLoginReset : PropTypes.func,
    requestUserDataReset : PropTypes.func,
};

module.exports.KeysSendDisasterViewContainer = connect(state => ({
    immUserData: state.userData,
    immCodeOTPData : state.codeOtp,
    immKeysData : state.recoveryKeys,
    immProfileFields: state.profile,
    immCustomerFinder: state.customerFinder,
    immLoginAsClient: state.loginAsClient,
}), {
    requestPhoneOTP: UserData.setPhoneOTPDisaster,
    requestcodeOTP : CodeOTP.sendPhoneOTPDisaster,
    requestSendKey : recoveryKeys.sendKeyDisaster,
    requestcodeOTPReset : CodeOTP.CodeOTPDataReset,
    requestSendKeyReset : recoveryKeys.KeyDataReset,
    requestGetProfile : profileActions.requestProfile,
    handleRequestLogin : loginAsClient.validateClientPin,
    requestClientLoginReset: loginAsClient.clientLoginReset,
    requestUserDataReset : UserData.UserDataReset
})(withRouter(KeysSendDisasterViewContainer));


